import { ApplicationState } from '@app/store'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import ForgotPasswordPage from '../components/ForgotPasswordPage'
import {
  actionCreators,
  IForgotPasswordState,
  selectError,
  selectHasRequestedPin,
  selectIsSaving,
  selectIsValid,
  selectPassword,
  selectPinCode,
  selectUsername,
  selectVerifyPassword,
} from '../modules/forgotPassword'

export default connect(
  createStructuredSelector<ApplicationState, IForgotPasswordState>({
    error: selectError(),
    hasRequestedPin: selectHasRequestedPin(),
    isSaving: selectIsSaving(),
    isValid: selectIsValid(),
    password: selectPassword(),
    pinCode: selectPinCode(),
    username: selectUsername(),
    verifyPassword: selectVerifyPassword(),
  }),
  actionCreators,
)(ForgotPasswordPage)
